const styles = theme => ({
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%"
  },
  imageContainer: {
    flex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > img": {
      // height: "100%"
    }
  },
  textContainer: {
    flex: 1
  },
  heading: {
    paddingTop: 30,
    textAlign: "center",
    color: theme.palette.primary.default
  },
  content: {
    width: "280px",
    textAlign: "center",
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/OnBoarding/components/OnBoardingContent/styles.js